export default {
      id: "chevron-usage",
      viewBox: "0 0 13 24",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#chevron",
      toString: function () {
        return this.url;
      }
    }